
import type { PropType } from 'vue'
import type { DispatcherWorkplaceCourier, DispatcherWorkplaceDataEntity } from '@/modules/DispatcherWorkplaceModule/types'

import { defineComponent } from 'vue'

import DwSidebarCourier from './Courier.vue'

export default defineComponent({
    components: {
        'dw-sidebar-courier': DwSidebarCourier
    },
    props: {
        couriers: {
            type: Array as PropType<Array<DispatcherWorkplaceCourier>>,
            default: () => []
        },
        showedRoutesCouriersIds: {
            type: Array as PropType<Array<number>>,
            default: () => []
        },
        isCompletedOrdersEnabled: {
            type: Boolean,
            default: false,
        },
        isProblemsEnabled: {
            type: Boolean,
            default: false,
        },
        isDeliveriesEnabled: {
            type: Boolean,
            default: false,
        },
        isUndeliveredDeliveriesEnabled: {
            type: Boolean,
            default: false,
        },
        isTakesEnabled: {
            type: Boolean,
            default: false,
        },
        isUnassignedTakesEnabled: {
            type: Boolean,
            default: false,
        },
        selectedSidebarFeatureId: {
            type: String as PropType<string | null>,
            default: null
        }
    },
    emits: ['show-route', 'entity-clicked'],
    setup(props, { emit }) {
        const onShowRoute = (courier: DispatcherWorkplaceCourier) => {
            emit('show-route', courier)
        }

        const onEntityClicked = (dataEntity: DispatcherWorkplaceDataEntity) => {
            emit('entity-clicked', dataEntity)
        }

        return {
            onShowRoute,
            onEntityClicked
        }
    }
})
